const GLOBAL = {
  app_type: 'responsive',
  app_name: 'bluey_movie',
  site_level2: 'Bluey Movie Microsite',
};

let download_count = 0;

const PAGE_DISPLAY = {
  id: 'PAGE_DISPLAY',
  type: 'page.display',
};

const CLICK_ACTION_POPCORN = {
  id: 'CLICK_ACTION_POPCORN',
  type: 'click.action',
  data: {
    click: 'interaction',
    item_name: 'popcorn',
    item_type: 'button',
    item_label: 'popcorn_click',
    url_event: window.location.href,
  },
};

const CLICK_ACTION_BALLOON = {
  id: 'CLICK_ACTION_BALLOON',
  type: 'click.action',
  data: {
    click: 'interaction',
    item_name: 'balloon',
    item_type: 'button',
    item_label: 'balloon_click',
    url_event: window.location.href,
  },
};

const CLICK_NAVIGATION_HEADER = {
  id: 'CLICK_NAVIGATION_HEADER',
  type: 'click.navigation',
  data: {
    click: 'Navigation Bar',
    item_name: '(name of option eg. Newsletter)',
    item_type: 'Navigation',
    item_link: '(url to destination)',
    url: window.location.href,
  },
};

const CLICK_EXIT = {
  id: 'CLICK_EXIT',
  type: 'click.exit',
  data: {
    item_name: 'poster',
    item_type: 'download',
    item_link: '(link to resource)',
    url_event: window.location.href,
    item_label: 0,
  },
};

const CLICK_NAVIGATION_FOOTER = {
  id: 'CLICK_NAVIGATION_FOOTER',
  type: 'click.navigation',
  data: {
    click: 'Footer Link',
    item_name: '(footer option name)',
    item_type: 'External Link',
    item_link: '(link to option)',
    url: window.location.href,
  },
};

export const TRACKING_EVENTS = {
  GLOBAL,
  PAGE_DISPLAY,
  CLICK_ACTION_POPCORN,
  CLICK_ACTION_BALLOON,
  CLICK_NAVIGATION_HEADER,
  CLICK_EXIT,
  CLICK_NAVIGATION_FOOTER,
};

export const incrementDownloadClickCount = () => {
  download_count = download_count + 1;
  return download_count;
};

export const track = (event, parameters = {}) => {
  if (!TRACKING_EVENTS[event]) return;

  let base = { ...GLOBAL };
  base =
    TRACKING_EVENTS[event].type === 'page.display'
      ? { ...base, ...parameters }
      : { ...base, ...TRACKING_EVENTS[event].data, ...parameters };

  console.log('track', TRACKING_EVENTS[event].type, base);
  window.pa?.sendEvent(TRACKING_EVENTS[event].type, base);
};
